export class BroadcastingElementBasic {

    private broadcastingElementInternalId: string;
    private urlElement: string;
    private urlElementThumbnail: string;
    private orderClip: number;
    private cycles: number;
    private timeClip: number;
    private titleElement: string;
    private type: string;
    private zoomLevel: number;

    constructor(broadcastingElementInternalId?: string, urlElement?: string, urlElementThumbnail?: string, orderClip?: number, cycles?: number, timeClip?: number, titleElement?: string, type?: string, zoomLevel?: number) {
        this.broadcastingElementInternalId = broadcastingElementInternalId;
        this.urlElement = urlElement;
        this.urlElementThumbnail = urlElementThumbnail;
        this.orderClip = orderClip;
        this.cycles = cycles;
        this.timeClip = timeClip;
        this.titleElement = titleElement;
        this.type = type;
        this.zoomLevel = zoomLevel;
    }

    public set BroadcastingElementInternalId(broadcastingElementInternalId) {
        this.broadcastingElementInternalId = broadcastingElementInternalId;
    }
    public set UrlElement(urlElement) {
        this.urlElement = urlElement;
    }
    public set UrlElementThumbnail(urlElementThumbnail) {
        this.urlElementThumbnail = urlElementThumbnail;
    }
    public set OrderClip(orderClip) {
        this.orderClip = orderClip;
    }
    public set Cycles(cycles) {
        this.cycles = cycles;
    }
    public set TimeClip(timeClip) {
        this.timeClip = timeClip;
    }
    public set TitleElement(titleElement) {
        this.titleElement = titleElement;
    }
    public set Type(type) {
        this.type = type;
    }
    public set ZoomLevel(zoomLevel) {
        this.zoomLevel = zoomLevel;
    }
    public get BroadcastingElementInternalId() {
        return this.broadcastingElementInternalId;
    }
    public get UrlElementThumbnail() {
        return this.urlElementThumbnail;
    }
    public get UrlElement() {
        return this.urlElement;
    }
    public get OrderClip() {
        return this.orderClip;
    }
    public get Cycles() {
        return this.cycles;
    }
    public get TimeClip() {
        return this.timeClip;
    }
    public get TitleElement() {
        return this.titleElement;
    }
    public get Type() {
        return this.type;
    }
    public get ZoomLevel() {
        return this.zoomLevel;
    }
}
